import { createContext, useContext } from 'react';

/**
 * Ревизия пачки 29, п.5 — «оплата сейчас физически не пройдёт».
 *
 * ЗАЧЕМ ОТДЕЛЬНЫЙ ПРИЗНАК, А НЕ ПРОП. Кнопка оплаты (BuyNowButton) живёт
 * глубоко внутри дерева экрана: её подставляет PaywallScreenWizard вместо
 * блоков `button_to_pay`/`stripe_checkout_form`, и рисуется она ещё и в
 * липкой полосе, и повтором внизу экрана. Тянуть проп через все эти места
 * означало бы четыре дороги для одного правила — а расходятся такие копии
 * молча (шрам WEB-1844). Поэтому правило одно и сверху: страница оплаты
 * объявляет «чекаут недоступен», все точки оплаты это видят.
 *
 * ЕДИНСТВЕННАЯ ПРИЧИНА СЕГОДНЯ — показ из последней хорошей копии воркера
 * (`servedStale`, WEB-1989 шаг 2): экран цен отдал край, а чекаут идёт в
 * живой API, которого сейчас нет. Докблоки `api/publicResolve.ts` и
 * `pages/PublicPaywall.tsx` обещали именно выключение кнопки — до этой
 * правки выключалась только плашка, и покупатель жал кнопку, после которой
 * ничего не происходит (класс WEB-933).
 *
 * По умолчанию `false`: везде, где провайдера нет (квиз, превью редактора,
 * отдельная страница оплаты при живом API), поведение прежнее.
 */
const CheckoutUnavailableContext = createContext<boolean>(false);

export const CheckoutUnavailableProvider = CheckoutUnavailableContext.Provider;

/** true → оплата сейчас не пройдёт, кнопки оплаты обязаны быть недоступны. */
export function useCheckoutUnavailable(): boolean {
  return useContext(CheckoutUnavailableContext);
}
